// Parse a user-supplied endpoint URL into a probe target for the deploy
// wizard's reachability check. The scheme is optional (defaults to https) so a
// bare host like `api.example.com` or `api.example.com:8443` works.
//
// Returns null when the input can't yield a concrete http(s) host — callers use
// that to decide whether an endpoint row is probeable. Unsupported schemes
// (e.g. ftp://) are rejected rather than silently coerced to https, since the
// probe only speaks http/https and coercing would test the wrong thing.
export function parseManualProbe(raw) {
  const s = (raw || '').trim();
  if (!s) return null;
  let u;
  try {
    u = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(s) ? s : `https://${s}`);
  } catch {
    return null;
  }
  if (!u.hostname) return null;
  if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
  const scheme = u.protocol === 'http:' ? 'http' : 'https';
  const port = u.port ? Number(u.port) : (scheme === 'http' ? 80 : 443);
  if (!Number.isInteger(port) || port < 1 || port > 65535) return null;
  return { host: u.hostname, port, scheme };
}
